/**
 * @fileoverview GET handler for the "/engagement/preset_landing_page_templates_data/:id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementPresetLandingPageTemplatesDataId } from "./constants";
import type { EngagementPresetLandingPageTemplatesDataIdResult } from "./types";
import { isEngagementPresetLandingPageTemplatesDataIdResult } from "./validators";

export const getEngagementPresetLandingPageTemplatesDataId = reactQueryFetcherAdapter(
  engagementPresetLandingPageTemplatesDataId,
  (signal: AbortSignal, id: string): Promise<EngagementPresetLandingPageTemplatesDataIdResult> => {
    return fetch(`/engagement/preset_landing_page_templates_data/${id}`, "GET", {}, { signal });
  },
  isEngagementPresetLandingPageTemplatesDataIdResult
);
